import React from 'react'
// import { Col, Container, Row } from 'react-bootstrap';
const Banner2 = ({ children, classList }) => {
  return (
    <>
      <section className={`${classList}`}>
        {children}
      </section>
    </>
  )
}

export default Banner2;
